module.exports = __webpack_public_path__ + "img/qr@2x.c0f04adb.png";